import React, { useEffect, useRef, useState } from "react";

const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const POS = { lat: 45.43273, lng: 11.93515 };
const ADDRESS = "Via Fornaci 215/B, 35131 Padova";

let mapsPromise = null;
const loadMapsApi = () => {
  if (window.google?.maps?.Map) return Promise.resolve();
  if (!mapsPromise) {
    mapsPromise = new Promise((resolve, reject) => {
      window.__idmMapsReady = () => resolve();
      const s = document.createElement("script");
      s.src = `https://maps.googleapis.com/maps/api/js?key=${KEY}&loading=async&callback=__idmMapsReady`;
      s.async = true;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return mapsPromise;
};

const GoogleMap = () => {
  const ref = useRef(null);
  const [failed, setFailed] = useState(!KEY);

  useEffect(() => {
    if (!KEY) return;
    let cancelled = false;
    window.gm_authFailure = () => setFailed(true);
    loadMapsApi()
      .then(() => {
        if (cancelled || !ref.current) return;
        const g = window.google.maps;
        const map = new g.Map(ref.current, {
          center: POS,
          zoom: 15,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          styles: [
            { featureType: "all", elementType: "geometry", stylers: [{ saturation: -55 }] },
            { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
          ],
        });
        const marker = new g.Marker({
          position: POS,
          map,
          title: "IdeaMedia",
          icon: {
            url: "/images/logo-marker.png",
            scaledSize: new g.Size(52, 52),
            anchor: new g.Point(26, 26),
          },
        });
        // if tiles never load (blocked network/renderer) switch to the embed fallback
        let tilesOk = false;
        g.event.addListenerOnce(map, "tilesloaded", () => {
          tilesOk = true;
        });
        setTimeout(() => {
          if (!tilesOk && !cancelled) setFailed(true);
        }, 8000);
        const info = new g.InfoWindow({
          content: `<div style="font-family:Lato,sans-serif;font-size:13px;line-height:1.7;color:#2d3032"><strong>IdeaMedia</strong><br/>${ADDRESS}<br/><a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(ADDRESS)}" target="_blank" rel="noreferrer" style="color:#2d3032;text-decoration:underline">Indicazioni stradali</a></div>`,
        });
        marker.addListener("click", () => info.open({ map, anchor: marker }));
      })
      .catch(() => setFailed(true));
    return () => {
      cancelled = true;
    };
  }, []);

  if (failed) {
    return (
      <div className="idm-map-wrap" data-testid="contact-map">
        <iframe
          title="IdeaMedia - Via Fornaci 215/B, 35131 Padova"
          src="https://www.google.com/maps?q=Via+Fornaci+215/B,+35131+Padova,+Italy&z=15&output=embed"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    );
  }
  return <div ref={ref} className="idm-map-js" data-testid="contact-map" />;
};

export default GoogleMap;
